import React from 'react'
import gql from 'graphql-tag'
import {Redirect} from 'react-router'
import Query from 'shared/components/Query'
import BookingOverview from './BookingOverview'
import Layout from 'components/PrivateRoutes/Layout'

const BOOKINGS_DETAIL_QUERY = gql`
  query BookingOverview($id: ID!) {
    serviceProvider {
      id
    }
    booking(id: $id) {
      id
      startsAt
      endsAt
      state
      pickUpKeysInstructions
      expressDelivery
      premiumService
      customerSpecificPriceListUrl
      isOpenDroneCategory
      instructionsForPhotographer {
        source
        instructions
      }
      textsFromStylists {
        stylist {
          name
          phone
        }
        text
      }
      estate {
        id
        invisoRef
        streetAddress
        postalCode
        floor
        doorbell
        additionalInfo
        postalArea
        segment {
          id
          name
        }
        location {
          lat
          lng:lon
        }
        estateSellers {
          id
          type
          name
          email
          phone
          phoneSecondary
        }
        bookedServiceProviders {
          id
          name
          phone
          email
        }
        broker {
          id
          name
          phone
          email
          phone
          customer {
            id
            name
            location {
              lat
              lng:lon
            }
            address {
              street
              postalCode
              postalArea
            }
            officeAddress {
              street
              postalCode
              postalArea
            }
          }
        }
        products {
          edges {
            node {
              id
              state
            }
          }
        }
      }
      products {
        edges {
          node {
            id
            name
            state
            requiredCapabilities
            ... on PhotoBasedProduct { quantity }
            ... on StylingProduct { plus }
            ... on MeasurementProduct { quantity usedAsInputFor { id } }
            ... on DigitalPlanDrawingProduct { productionReference, weScanLink }
            ... on VideoProduct {
              drone, videoVariant,
              features { id, name, value }
            }
          }
        }
      }
      availableProducts {
        edges {
          node {
            id
            name
            __typename
            ... on PhotoBasedProduct { minQuantity }
          }
        }
      }
      orderInvoiceLines(orderOrigin: "serviceproviderapp") {
        id
        createdAt
        description
        quantity
        unitPrice
      }
    }
  }
`

const BookingOverviewPage = (props) => {
  const {id} = props.match.params

  return (
    <Query
      query={BOOKINGS_DETAIL_QUERY}
      variables={{id}}
      inlineLoading
      inlineError
    >
      {
        ({getData}) => {
          const booking = getData('booking')
          const viewerId = getData('serviceProvider.id')

          if (!booking) {
            return <Redirect to="/bookings" />
          }

          return (
            <Layout
              {...props}
              title={`${booking.estate.streetAddress}, ${booking.estate.postalCode} ${booking.estate.postalArea}`}
              defaultBackTo="/bookings"
            >
              <div className="booking-details-page">
                <BookingOverview booking={booking} viewerId={viewerId} />
              </div>
            </Layout>
          )
        }
      }
    </Query>
  )
}

export default BookingOverviewPage
